module.exports = __webpack_public_path__ + "img/研究院logo白底.34cbace7.png";